/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import { useEffect, useState } from "react";

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import GradientBorder from "examples/GradientBorder";

// Vision UI Dashboard assets
import radialGradient from "assets/theme/functions/radialGradient";
import palette from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

// Moralis
import { useMoralis } from "react-moralis";
import { Link } from "@mui/material";

function SuportUs() {
  const { Moralis, account } = useMoralis();
  const [userTelegram, setUserTelegram] = useState("");
  const [email, setEmail] = useState("");
  const [pending, setPending] = useState(false);
  const [showLink, setShowLink] = useState("none");
  const [contracts, setContracts] = useState({});

  useEffect(() => {
    getContracts();
  }, []);

  const getContracts = async () => {
    try {
      const getContracts = Moralis.Object.extend("Contracts");
      const query = new Moralis.Query(getContracts);
      const results = await query.find();
      setContracts(results[0].attributes);
    } catch (err) {
      return Promise.reject(err);
    }
  };

  const addressAccount = contracts.contractWallet;
  const contractBUSD = contracts.contractBUSD;
  const contractUSDT = contracts.contractUSDT;
  const contractUSDC = contracts.contractUSDC;
  const paymentAmount = contracts.contractAmount;
  const telegramSuportLink = contracts.telegramLink;

  const handlePaymentBUSD = () => handlePayment(contractBUSD);
  const handlePaymentUSDT = () => handlePayment(contractUSDT);
  const handlePaymentUSDC = () => handlePayment(contractUSDC);

  const handlePayment = async (stableContract) => {
    // sending BUSD, USDT, USDC tokens with 18 decimals
    const options = {
      type: "erc20",
      amount: Moralis.Units.Token(paymentAmount, "18"),
      receiver: addressAccount,
      contractAddress: stableContract,
    };
    setPending(true);
    const txStatus = await Moralis.transfer(options);
    const response = await txStatus.wait();
    const txHash = response.transactionHash;

    if (txHash) {
      // save transactions details to DB
      const Transaction = Moralis.Object.extend("Transaction");
      const transaction = new Transaction();
      transaction
        .save({
          customerWalletAddress: account,
          transactionHash: `https://bscscan.com/tx/${txHash}`,
          userTelegram: userTelegram,
          email: email,
        })
        .then(() => alert("Transaction succesfully made!!!"));
      setPending(false);
      setShowLink("");
    }
  };

  return (
    <GradientBorder borderRadius={borders.borderRadius.form} minWidth="100%" maxWidth="100%">
      <VuiBox
        component="form"
        role="form"
        borderRadius="inherit"
        p="45px"
        sx={({ palette: { secondary } }) => ({
          backgroundColor: secondary.focus,
        })}
      >
        <VuiTypography
          color="white"
          fontWeight="bold"
          textAlign="center"
          mb="24px"
          sx={({ typography: { size } }) => ({
            fontSize: size.lg,
          })}
        >
          Suport Us
        </VuiTypography>

        <VuiBox mb={2}>
          <VuiBox mb={1} ml={0.5}>
            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
              User Telegram
            </VuiTypography>
          </VuiBox>
          <GradientBorder
            minWidth="100%"
            borderRadius={borders.borderRadius.lg}
            padding="1px"
            backgroundImage={radialGradient(
              palette.gradients.borderLight.main,
              palette.gradients.borderLight.state,
              palette.gradients.borderLight.angle
            )}
          >
            <VuiInput
              required
              placeholder="@mrcrypto"
              sx={({ typography: { size } }) => ({
                fontSize: size.sm,
              })}
              onChange={(e) => setUserTelegram(e.target.value)}
            />
          </GradientBorder>
        </VuiBox>
        <VuiBox mb={2}>
          <VuiBox mb={1} ml={0.5}>
            <VuiTypography component="label" variant="button" color="white" fontWeight="medium">
              Email
            </VuiTypography>
          </VuiBox>
          <GradientBorder
            minWidth="100%"
            borderRadius={borders.borderRadius.lg}
            padding="1px"
            backgroundImage={radialGradient(
              palette.gradients.borderLight.main,
              palette.gradients.borderLight.state,
              palette.gradients.borderLight.angle
            )}
          >
            <VuiInput
              type="email"
              placeholder="Your email..."
              sx={({ typography: { size } }) => ({
                fontSize: size.sm,
              })}
              onChange={(e) => setEmail(e.target.value)}
            />
          </GradientBorder>
        </VuiBox>

        <VuiTypography
          color="text"
          fontWeight="bold"
          textAlign="center"
          mt="24px"
          sx={({ typography: { size } }) => ({ fontSize: size.lg })}
        >
          with
        </VuiTypography>

        <VuiBox mt={4} mb={1}>
          <VuiButton color="primary" variant="gradient" fullWidth onClick={handlePaymentBUSD}>
            {paymentAmount} BUSD
          </VuiButton>
        </VuiBox>
        <VuiBox mt={4} mb={1}>
          <VuiButton color="primary" variant="gradient" fullWidth onClick={handlePaymentUSDT}>
            {paymentAmount} USDT
          </VuiButton>
        </VuiBox>
        <VuiBox mt={4} mb={1}>
          <VuiButton color="primary" variant="gradient" fullWidth onClick={handlePaymentUSDC}>
            {paymentAmount} USDC
          </VuiButton>
        </VuiBox>

        <VuiTypography
          color="light"
          fontWeight="bold"
          textAlign="center"
          mt="30px"
          sx={({ typography: { size } }) => ({ fontSize: size.lg })}
          display={showLink}
        >
          <Link href={telegramSuportLink} target="_blank">
            <VuiButton color="secondary" variant="gradient">
              Join Mr.Crypto Suport Channel
            </VuiButton>
          </Link>
        </VuiTypography>
      </VuiBox>
    </GradientBorder>
  );
}

export default SuportUs;
